<template>
  <div class="caption">
    <navigation type="second-level" :sticky="true">身份认证说明</navigation>

    <section class="content">
      <ul class="first-list">
        <li class="first-item">身份证必须真实有效，且为本人。否则借款将无法通过，且无法重新申请</li>
        <li class="first-item">提高身份证识别成功率，请参照下方示例：</li>
      </ul>
      <ul class="secondary-list">
        <li class="secondary-item">保证整张身份证位于提示框以内，并对齐框边缘；</li>
        <li class="secondary-item">保持光度亮度均匀，明暗适中，不要出现暗区，也不要出现反光；</li>
        <li class="secondary-item">点击屏幕自动对焦，拍摄过程中减少手机晃动；</li>
        <li class="secondary-item">长时间无反应，可退出后重新进入验证。</li>
      </ul>

      <figure class="id-card">
        <img class="img-card" src="./images/img_idcard.png" srcset="./images/img_idcard@2x.png 2x, ./images/img_idcard@3x.png 3x">
        <figcaption class="img-caption">建议将身份证置于平整桌面上，并垫上白纸</figcaption>
      </figure>

    </section>

    <section class="footer">
      <p class="title-caption">【错误示例】</p>
      <div class="error-collection">
        <figure class="id-card-error">
          <img class="img-card-error" src="./images/img_card_error_01.png" srcset="./images/img_card_error_01@2x.png 2x, ./images/img_card_error_01@3x.png 3x">
          <figcaption class="img-caption">镜头未对焦</figcaption>
        </figure>
        <figure class="id-card-error card-right">
          <img class="img-card-error" src="./images/img_card_error_02.png" srcset="./images/img_card_error_02@2x.png 2x, ./images/img_card_error_02@3x.png 3x">
          <figcaption class="img-caption">反光有亮斑</figcaption>
        </figure>
        <figure class="id-card-error">
          <img class="img-card-error" src="./images/img_card_error_03.png" srcset="./images/img_card_error_03@2x.png 2x, ./images/img_card_error_03@3x.png 3x">
          <figcaption class="img-caption">不完整</figcaption>
        </figure>
        <figure class="id-card-error  card-right">
          <img class="img-card-error" src="./images/img_card_error_04.png" srcset="./images/img_card_error_04@2x.png 2x, ./images/img_card_error_04@3x.png 3x">
          <figcaption class="img-caption">临时证件</figcaption>
        </figure>
      </div>

    </section>


  </div>
</template>

<script>
import Navigation from '../../components/navigation/index'

export default {
  name: 'id-guide',
  components: { Navigation },
  created () {
    this.$bus.$emit('ready')
  }
}
</script>

<style scoped lang="less">
@import "../../assets/less/mixin.less";


    .caption {
        height: 100%;
        width: 100%;
        overflow: scroll;
        color: #333333;
        font-family: PingFangSC-Regular;

        .content {
            .first-list {
                list-style-type: none;
                counter-reset: count;
                margin: 39px 40px 0;

                .first-item {
                    display: flex;
                    font-size: 30px;
                    align-items: stretch;
                    font-family: PingFangSC-Semibold;
                    margin-top: 39px;

                    &::before {
                        content: counter(count) '、';
                        counter-increment: count;
                    }
                }
            }

            .secondary-list {
                margin: 39px 56.00000000000001px 0 56.00000000000001px;

                .secondary-item {
                    display: flex;
                    align-items: stretch;
                    color: #666666;
                    font-size: 26px;
                    margin-top: 23px;

                    &::before {
                        content: '•';
                        font-size: 26px;
                        color: #DDDDDD;
                        margin-right: 18px;
                    }
                }
            }

            .id-card {
                margin-top: 39px;

                .img-card {
                    width: 304px;
                    height: 200px;
                    display: block;
                    margin: 0 auto;
                }

                .img-caption {
                    color: #666666;
                    font-size: 28.000000000000004px;
                    text-align: center;
                    margin-top: 28.000000000000004px;
                }
            }


        }


        .footer {
            margin-top: 52px;
            margin-bottom: 71px;

            .title-caption {
                margin-left: 38px;
                font-size: 30px;
                font-family: PingFangSC-Semibold;
            }

            .error-collection {
                margin: 0 66px;

                .id-card-error {
                    display: inline-block;
                    width: 45%;
                    margin-top: 34px;
                    font-size: 0;

                    .img-card-error {
                        width: 100%;
                        margin: 0;
                    }

                    .img-caption {
                        color: #666666;
                        font-size: 28.000000000000004px;
                        text-align: center;
                        margin-top: 19px;
                    }

                }

                .card-right {
                    float: right;
                }
            }


        }


    }


</style>